import { useState, useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
    Grid, TextField, Button,
    Typography
} from '@mui/material';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import axios from "axios";
import Helpers from "../Helpers";
import CardPedido from "../components/CardPedido";

const dataAtual = () => {
    const dataAtual = new Date();
    const dia = String(dataAtual.getDate()).padStart(2, '0');
    const mes = String(dataAtual.getMonth() + 1).padStart(2, '0'); // janeiro é 0
    const ano = dataAtual.getFullYear();

    const dataFormatada = `${ano}-${mes}-${dia}`;
    return dataFormatada;
};

function Vendas() {
    const location = useLocation();
    const filtro = location.state?.params;
    const [urlApi, setUrlApi] = useState(process.env.REACT_APP_URL_API);
    const [listaFiltrada, setListaFiltrada] = useState([]);
    const [valorTotalLista, setValorTotalLista] = useState(0);
    const [filtroPedidos, setFiltroPedidos] = useState({
        dtInicial: dataAtual(),
        dtFinal: dataAtual(),
    });
    const [idFuncionario, setIdFuncionario] = useState(null);

    const getAuth = ()=>{
        const data = localStorage.getItem('userAuth');

        if(data != null){
            let user = JSON.parse(data);
            setIdFuncionario(user.id_funcionario);
        }
    };

    const getVendasApi = async (funcionario_id, dt_inicial, dt_final) => {
        Helpers.loadingAlert('Atualizando histórico de pedidos');
        const rota = `${urlApi}/${funcionario_id}/vendas/${dt_inicial}/${dt_final}`;
        const resposta = await axios.get(rota);
        const data = resposta.data;

        setListaFiltrada(data.lista);
        setValorTotalLista(data.vrTotal);
    };

    useEffect(() => {
        setTimeout(() => {
            getAuth();

            if(idFuncionario !== null){
                getVendasApi(idFuncionario, filtroPedidos.dtInicial, filtroPedidos.dtFinal);
            }

        }, 1000);
    }, [idFuncionario]);

    useEffect(() => {
        if(!filtro) return;
        
        setTimeout(() => {
            setFiltroPedidos({
                dtInicial: filtro.dtInicial,
                dtFinal: filtro.dtFinal,
            });

            if(idFuncionario !== null){
                getVendasApi(idFuncionario, filtro.dtInicial, filtro.dtFinal);
            }
        }, 1000);
    }, [filtro]);

    return (
        <Grid container rowSpacing={2}>
            <Grid container columnSpacing={1} >
                <Grid size={{ xs: 5, md: 5 }} >
                    <TextField
                        id="dtInicial"
                        type="date"
                        label="Data inicial"
                        variant="outlined"
                        size="small"
                        value={filtroPedidos.dtInicial}
                        onChange={(e) =>
                            setFiltroPedidos((prev) => ({ ...prev, dtInicial: e.target.value }))
                        }
                        sx={{ backgroundColor: '#fff' }}
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                    />
                </Grid>
                <Grid size={{ xs: 5, md: 5 }} >
                    <TextField
                        id="dtFinal"
                        type="date"
                        label="Data final"
                        variant="outlined"
                        size="small"
                        value={filtroPedidos.dtFinal}
                        onChange={(e) =>
                            setFiltroPedidos((prev) => ({ ...prev, dtFinal: e.target.value }))
                        }
                        sx={{ backgroundColor: '#fff' }}
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                    />
                </Grid>
                <Grid size={{ xs: 1, md: 2 }} >
                    <Button
                        variant="outlined"
                        size="large"
                        onClick={() => getVendasApi(idFuncionario, filtroPedidos.dtInicial, filtroPedidos.dtFinal)}
                    >
                        <PersonSearchIcon />
                    </Button>
                </Grid>
            </Grid>

            <Grid size={{ xs: 12, md: 12 }} sx={{ marginBottom: 1, borderBottom: '3px solid #DA0C16', display: 'flex', justifyContent: 'space-between' }}>
                <Typography sx={{ fontWeight: 'bold' }}>{`${listaFiltrada.length} pedidos encontrados`} </Typography>
                <Typography sx={{ fontWeight: 'bold' }}>{`Total vendido: R$ ${Helpers.formataValorPtBr(valorTotalLista)}`} </Typography>
            </Grid>

            <Grid container sx={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', gap: 1 }}>
                {
                    (listaFiltrada.length > 0) &&
                    listaFiltrada.map((item, index) => {
                        let tamanhoGrid = 4;
                        if (listaFiltrada.length <= 2) { tamanhoGrid = 12 };

                        return <CardPedido key={index} item={item} filtroPedidos={filtroPedidos}/>;
                    })
                }
            </Grid>
        </Grid>
    );
}

export default Vendas;